/**
 *
 */
export enum RoomAdvertUserViewTypeID {
  FromSearchResult = 1,
  FromMyMatch = 2,
  FromAlertEmail = 3,
}
